// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.directions .showings-list, .directions .current-showing {
  position: absolute;
  bottom: 16px;
  width: 500px;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.1);
  border-radius: 16px;
  left: 0;
  padding: 16px;
  right: 0;
}
.directions .current-showing {
  display: flex;
  align-items: center;
  z-index: 5;
}
.directions .current-showing .current-showing-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  padding-right: 16px;
  justify-content: space-between;
}
.directions .current-showing .show-more {
  position: relative;
  flex: none;
  padding: 0 10px 0 26px;
}
.directions .current-showing .show-more::before {
  content: "";
  position: absolute;
  left: 0;
  top: -24px;
  width: 0.4px;
  height: 80px;
  background-color: #DFDFDF;
}
.directions .showings-list {
  bottom: 80px;
  opacity: 0;
  transition: 0.5s ease-in-out;
  z-index: 4;
  visibility: hidden;
  min-height: 80px;
  height: auto;
}
.directions .showings-list.show {
  visibility: visible;
  opacity: 1;
  bottom: 112px;
}
.directions .showings-list .showing-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.directions .direction-details {
  position: absolute;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  left: -316px;
  height: calc(100vh - 92px);
  top: 16px;
  background-color: white;
  box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.1);
  border-radius: 24px;
  transition: 0.8s ease-in-out;
}
.directions .direction-details.show {
  left: 16px;
}
.directions .direction-details .showing-details {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 0 16px;
}
.directions .direction-details .showing-details > img {
  height: 120px;
  width: 100%;
  object-fit: cover;
  border-radius: 16px;
}
.directions .direction-details .showing-details .participants ul {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.directions .direction-details .showing-details .participants ul li {
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #2A2A2A;
}
.directions .direction-details .showing-details .participants ul li p {
  margin: 0;
}
.directions .direction-details .showing-details .participants ul li img {
  height: 20px;
  width: 20px;
  object-fit: cover;
  border-radius: 100%;
}
.directions .direction-details .direction-routes {
  padding-top: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
}
.directions .direction-details .direction-routes::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0px;
  width: 300px;
  height: 1px;
  background-color: #DFDFDF;
}
.directions .direction-details .direction-routes .location-input-wrapper {
  display: flex;
  column-gap: 14px;
  padding: 0 16px;
  align-items: center;
}
.directions .direction-details .direction-routes .location-input-wrapper .location-input {
  flex: 1 1;
  width: 100%;
  position: relative;
}
.directions .direction-details .direction-routes .location-input-wrapper .location-input .predictions {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  background-color: white;
  border-radius: 8px;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #2A2A2A;
  border: 1px solid #DFDFDF;
  position: absolute;
  padding: 8px 0;
  animation: slidedown 0.3s ease-in-out;
  z-index: 10;
  margin-right: 16px;
  width: 100%;
}
.directions .direction-details .direction-routes .location-input-wrapper .location-input .predictions > li {
  padding: 8px 16px;
  cursor: pointer;
}
.directions .direction-details .direction-routes .location-input-wrapper .location-input .predictions > li:hover {
  background-color: #F5F5F5;
}
.directions .direction-details .direction-routes .routes-list .route-options {
  display: flex;
  column-gap: 8px;
}
.directions .direction-details .direction-routes .routes-list .route-options > a {
  transition: 0.3s ease-in-out;
}
.directions .direction-details .direction-routes .routes-list .route-options > a:hover {
  opacity: 0.75;
}
.directions .direction-details .direction-routes .routes-list ul {
  display: flex;
  flex-direction: column;
  border-bottom: 0.4px solid var(--Dark-dark-100, #DFDFDF);
}
.directions .direction-details .direction-routes .routes-list ul li {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 16px;
  justify-content: space-between;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  border-top: 0.4px solid var(--Dark-dark-100, #DFDFDF);
  background-color: white;
  position: relative;
}
.directions .direction-details .direction-routes .routes-list ul li.selected::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-color: #FAC91F;
}
.directions .direction-details .direction-routes .routes-list ul li:hover {
  opacity: 0.75;
}
.directions .direction-details .direction-routes .routes-list ul li p {
  margin: 0;
}
.directions .direction-details .back-button {
  display: flex;
  justify-content: center;
  padding: 16px;
}
.directions .direction-details .back-button > button {
  width: 100%;
}

.not-available {
  position: absolute;
  margin: auto;
  background-color: white;
  box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.1);
  border-radius: 16px;
  padding: 16px;
  width: 300px;
  height: -moz-fit-content;
  height: fit-content;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
}
.not-available p {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #2A2A2A;
  text-align: center;
}
.not-available .not-available-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #FAC91F;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingsMap/modules/directions.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kDAAA;EACA,mBAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;AAAR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AAAR;AACQ;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AACZ;AACQ;EACI,kBAAA;EACA,UAAA;EACA,sBAAA;AACZ;AAAY;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AAEhB;AAEI;EACI,YAAA;EACA,UAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAAR;AACQ;EACI,mBAAA;EACA,UAAA;EACA,aAAA;AACZ;AACQ;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACZ;AAEI;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,SAAA;EACA,uBAAA;EACA,kDAAA;EACA,mBAAA;EACA,4BAAA;AAAR;AACQ;EACI,UAAA;AACZ;AACQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AACZ;AAAY;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAEhB;AACgB;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACpB;AAAoB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAExB;AADwB;EACI,SAAA;AAG5B;AADwB;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAG5B;AAGQ;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AADZ;AAEY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAAhB;AAEY;EACI,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAhB;AACgB;EACI,SAAA;EACA,WAAA;EACA,kBAAA;AACpB;AAAoB;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAExB;AADwB;EACI,iBAAA;EACA,eAAA;AAG5B;AAF4B;EACI,yBAAA;AAIhC;AAGgB;EACI,aAAA;EACA,eAAA;AADpB;AAEoB;EACI,4BAAA;AAAxB;AACwB;EACI,aAAA;AAC5B;AAGgB;EACI,aAAA;EACA,sBAAA;EACA,wDAAA;AADpB;AAEoB;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,4BAAA;EACA,qDAAA;EACA,uBAAA;EACA,kBAAA;AAAxB;AAE4B;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAAhC;AAGwB;EACI,aAAA;AAD5B;AAGwB;EACI,SAAA;AAD5B;AAOQ;EACI,aAAA;EACA,uBAAA;EACA,aAAA;AALZ;AAMY;EACI,WAAA;AAJhB;;AASA;EACI,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,kDAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;EAAA,mBAAA;EACA,SAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AANJ;AAOI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AALR;AAOI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALR","sourcesContent":[".directions {\n    .showings-list, .current-showing {\n        position: absolute;\n        bottom: 16px;\n        width: 500px;\n        height: 80px;\n        margin-left: auto;\n        margin-right: auto;\n        background-color: white;\n        box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.10);\n        border-radius: 16px;\n        left: 0;\n        padding: 16px;\n        right: 0;\n    }\n    .current-showing {\n        display: flex;\n        align-items: center;\n        z-index: 5;\n        .current-showing-content {\n            flex: 1;\n            display: flex;\n            align-items: center;\n            padding-right: 16px;\n            justify-content: space-between; \n        }\n        .show-more {\n            position: relative;\n            flex: none;\n            padding: 0 10px 0 26px;\n            &::before {\n                content: '';\n                position: absolute;\n                left: 0;\n                top: -24px;\n                width: .4px;\n                height: 80px;\n                background-color: #DFDFDF;\n            }\n        }\n    }\n    .showings-list {\n        bottom: 80px;\n        opacity: 0;\n        transition: .5s ease-in-out;\n        z-index: 4;\n        visibility: hidden;\n        min-height: 80px;\n        height: auto;\n        &.show {\n            visibility: visible;\n            opacity: 1;\n            bottom: 112px;\n        }\n        .showing-item {\n            flex: 1;\n            display: flex;\n            align-items: center;\n            justify-content: space-between; \n        }\n    }\n    .direction-details {\n        position: absolute;\n        padding: 16px 0;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        width: 300px;\n        left: -316px;\n        height: calc(100vh - 92px);\n        top: 16px;\n        background-color: white;\n        box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.10);\n        border-radius: 24px;\n        transition: .8s ease-in-out;\n        &.show {\n            left: 16px;\n        }\n        .showing-details {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            row-gap: 16px;\n            padding: 0 16px;\n            > img {\n                height: 120px;\n                width: 100%;\n                object-fit: cover;\n                border-radius: 16px;\n            }\n            .participants {\n                ul {\n                    display: flex;\n                    flex-direction: column;\n                    row-gap: 8px;\n                    li {\n                        display: flex;\n                        align-items: center;\n                        column-gap: 8px;\n                        font-size: 12px;\n                        font-weight: 600;\n                        color: #2A2A2A;\n                        p {\n                            margin: 0;\n                        }\n                        img {\n                            height: 20px;\n                            width: 20px;\n                            object-fit: cover;\n                            border-radius: 100%;\n                        }\n                    }\n                }\n            }\n        }\n        .direction-routes {\n            padding-top: 16px;\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            &::before {\n                content: '';\n                position: absolute;\n                top: 0;\n                left: -0px;\n                width: 300px;\n                height: 1px;\n                background-color: #DFDFDF;\n            }\n            .location-input-wrapper {\n                display: flex;\n                column-gap: 14px;\n                padding: 0 16px;\n                align-items: center;\n                .location-input {\n                    flex: 1;\n                    width: 100%;\n                    position: relative;\n                    .predictions {\n                        display: flex;\n                        flex-direction: column;\n                        row-gap: 8px;\n                        background-color: white ;\n                        border-radius: 8px;\n                        margin-top: 8px;\n                        font-size: 12px;\n                        font-weight: 500;\n                        color: #2A2A2A;\n                        border: 1px solid #DFDFDF;\n                        position: absolute;\n                        padding: 8px 0;\n                        animation: slidedown .3s ease-in-out;\n                        z-index: 10;\n                        margin-right: 16px;\n                        width: 100%;\n                        > li {\n                            padding: 8px 16px;\n                            cursor: pointer;\n                            &:hover {\n                                background-color: #F5F5F5;\n                            }\n                        }\n                    }\n                }\n            }\n            .routes-list {\n                .route-options {\n                    display: flex;\n                    column-gap: 8px;\n                    > a {\n                        transition: .3s ease-in-out;\n                        &:hover {\n                            opacity: .75;\n                        }\n                    }\n                }\n                ul {\n                    display: flex;\n                    flex-direction: column;\n                    border-bottom: 0.4px solid var(--Dark-dark-100, #DFDFDF);\n                    li {\n                        height: 60px;\n                        display: flex;\n                        align-items: center;\n                        padding: 16px;\n                        justify-content: space-between;\n                        cursor: pointer;\n                        transition: .3s ease-in-out;\n                        border-top: 0.4px solid var(--Dark-dark-100, #DFDFDF);\n                        background-color: white;\n                        position: relative;\n                        &.selected {\n                            &::before {\n                                content: '';\n                                position: absolute;\n                                left: 0;\n                                top: 0;\n                                width: 4px;\n                                height: 100%;\n                                background-color: #FAC91F;\n                            }\n                        }\n                        &:hover {\n                            opacity: .75;\n                        }\n                        p {\n                            margin: 0;\n                        }\n                    }\n                }\n            }\n        }\n        .back-button {\n            display: flex;\n            justify-content: center;\n            padding: 16px;\n            > button {\n                width: 100%;\n            }\n        }\n    }\n}\n.not-available {\n    position: absolute;\n    margin: auto;\n    background-color: white;\n    box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.10);\n    border-radius: 16px;\n    padding: 16px;\n    width: 300px;\n    height: fit-content;\n    bottom: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 16px;\n    p {\n        margin: 0;\n        font-size: 16px;\n        font-weight: 700;\n        color: #2A2A2A;\n        text-align: center;\n    }\n    .not-available-icon {\n        width: 40px;\n        height: 40px;\n        border-radius: 8px;\n        background-color: #FAC91F;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
